import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

// Material
import {MatIconModule} from '@angular/material/icon'
import {MatButtonModule} from '@angular/material/button'
import {MatTooltipModule} from '@angular/material/tooltip'
import {MatToolbarModule} from '@angular/material/toolbar'
import {MatMenuModule} from '@angular/material/menu'
import {MatListModule} from '@angular/material/list'
import {MatRippleModule} from '@angular/material/core'
import {MatBadgeModule} from '@angular/material/badge'

import { MenusModule } from 'src/app/modules/menus/menus.module'
import { HeaderComponent } from './components/header/header.component'
import { VerticalMenuComponent } from './components/vertical-menu/vertical-menu.component'
import { RouterModule } from '@angular/router'
import { FeatureFlagDirective } from 'src/app/feature-flag.directive'
import { UserMenuItemComponent } from 'src/app/user-menu-item/user-menu-item.component'



@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MenusModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatToolbarModule,
        MatMenuModule,
        MatListModule,
        MatRippleModule,
        MatBadgeModule,
        FeatureFlagDirective,
        UserMenuItemComponent,
        HeaderComponent, VerticalMenuComponent
    ],
    exports: [
        MenusModule, HeaderComponent, VerticalMenuComponent
    ]
})
export class TemplateModule { }
